import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CONTROL_TEXTS } from '../../utils/customFieldsUtils';
import CheckboxControl from './CheckboxControll';

const CustomFieldControls = ({
  isActive, setIsActive, isEncrypted, setIsEncrypted, isRequired, setIsRequired, selectedType = null,
}) => {
  const [errorMessage, setErrorMessage] = useState('');

  // Function to toggle isActive
  const toggleActive = () => {
    if (isRequired) {
      setErrorMessage('This field is required. If you would like to deactivate it, please first make it optional.');
      return;
    }
    setErrorMessage('');
    setIsActive(!isActive);
  };

  // Function to toggle isRequired
  const toggleRequired = () => {
    setIsRequired(!isRequired);
    if (!isRequired) {
      setIsActive(true); // Ensure that if a field is required, it remains active
    }
    setErrorMessage('');
  };

  return (
    <div className="border-b border-vamos-blue-gray">
      <h2 className="font-bold text-lg text-left my-4">Controls</h2>

      {/* Active Checkbox */}
      <CheckboxControl
        id="active"
        label={CONTROL_TEXTS.active.title}
        description={CONTROL_TEXTS.active.description}
        isChecked={isActive}
        onToggle={toggleActive}
        error={errorMessage}
      />

      {/* Error message when trying to deactivate a required field */}
      {errorMessage && <p className="text-vamos-red text-sm mb-4">{errorMessage}</p>}

      {/* Encrypt and Required checkboxes (not for Heading type) */}
      {selectedType?.value !== 'FormItem::Heading' && (
        <>
          {/* Encrypt Checkbox */}
          <CheckboxControl
            id="encrypt"
            label={CONTROL_TEXTS.encrypt.title}
            description={CONTROL_TEXTS.encrypt.description}
            isChecked={isEncrypted}
            onToggle={() => setIsEncrypted(!isEncrypted)}
          />
          {/* Required Checkbox */}
          <CheckboxControl
            id="required"
            label={CONTROL_TEXTS.required.title}
            description={CONTROL_TEXTS.required.description}
            isChecked={isRequired}
            onToggle={toggleRequired}
          />
        </>
      )}
    </div>
  );
};

CustomFieldControls.propTypes = {
  isActive: PropTypes.bool.isRequired,
  setIsActive: PropTypes.func.isRequired,
  isEncrypted: PropTypes.bool.isRequired,
  setIsEncrypted: PropTypes.func.isRequired,
  isRequired: PropTypes.bool.isRequired,
  setIsRequired: PropTypes.func.isRequired,
  selectedType: PropTypes.object,
};

export default CustomFieldControls;
